<template>
    <a :href="url" @click.prevent="toggle" class="bordered-icon btn-help" target="_blank" v-if="url">
        <font-awesome-icon :icon="['fas','question']" />
    </a>
</template>
<script>
export default {
    mounted(){
        var self = this;
        this.url =  this.$hisport && 
                    this.$hisport.options &&
                    this.$hisport.options.platform && 
                    this.$hisport.options.platform.help &&
                    this.$hisport.options.platform.help.routes &&
                    this.$router &&
                    this.$router.currentRoute && 
                    Array.isArray(this.$router.currentRoute.matched) && 
                    this.$router.currentRoute.matched.map(function(r){
                        return self.$hisport.options.platform.help.routes[r.path]
                    }).find(x=>!!x)
    }, 
    beforeDestroy(){
        if(this.w) this.w.close()
        this.$store.dispatch("hideHelp");
    },
    data(){
        return {
            url: undefined,
            w:null
        }
    },
    methods:{
        toggle(){
            if(this.$store.getters.help){
                this.$store.dispatch("hideHelp");
            }else{
                this.$store.dispatch("showHelp", this.url);
            }
        },
        openWindow(){
            try{
                var hw = window.screen.width * 0.4;
                var hh = window.screen.height;
                var l = 200;
            var t = 0;
            }catch(ex){
                hw = 200;
                hh = 200;
                l = 0;
                t = 0;
            }
            var opts =  "toolbar=no," +
                        "location=no," +
                        "status=no," +
                        "menubar=no," +
                        "scrollbars=yes," +
                        "resizable=yes," +
                        "top=" + String(t) + "px," +
                        "left=" + String(l) + "px," +
                        "width=" + String(hw) + "px," +
                        "height=" + String(hh) +"px";
                        console.log("OPTS", opts)
            this.w = window.open(this.url, "help",  opts)
        }
    }

}
</script>
